import getBrandName from '@/services/app-branding/helpers/getBrandName';

export default function hasWinckBranding() {
    return getBrandName() === 'WINCK';
}
